import {ParamsModel} from 'src/app/modules/common/Model'
import {AbroadRepresentativeModel} from '../Model'
import {actionTypes} from './constants'
import {BulkAction} from './service'

export const actions = {
  getAbroadRepresentative: (params: ParamsModel = {page: 1, limit: 10}) => ({
    type: actionTypes.GET_ABROAD_REPRESENTATIVE_START,
    payload: params,
  }),
  getAbroadRepresentativeSuccess: (data: any) => ({
    type: actionTypes.GET_ABROAD_REPRESENTATIVE_SUCCESS,
    payload: data,
  }),
  getAbroadRepresentativeFinish: () => ({type: actionTypes.GET_ABROAD_REPRESENTATIVE_FINISH}),

  addAbroadRepresentative: (data: AbroadRepresentativeModel) => ({
    type: actionTypes.ADD_ABROAD_REPRESENTATIVE_START,
    payload: data,
  }),
  updateAbroadRepresentative: (data: AbroadRepresentativeModel, id: string) => ({
    type: actionTypes.UPDATE_ABROAD_REPRESENTATIVE_START,
    payload: {data, id},
  }),
  saveAbroadRepresentativeSuccess: () => ({type: actionTypes.SAVE_ABROAD_REPRESENTATIVE_SUCCESS}),
  saveAbroadRepresentativeFinish: () => ({type: actionTypes.SAVE_ABROAD_REPRESENTATIVE_FINISH}),

  bulkAbroadRepresentative: (action: BulkAction, ids: string[]) => ({
    type: actionTypes.BULK_ABROAD_REPRESENTATIVE_START,
    payload: {action, ids},
  }),
  bulkAbroadRepresentativeSuccess: (action: BulkAction) => ({
    type: actionTypes.BULK_ABROAD_REPRESENTATIVE_SUCCESS,
    payload: action,
  }),
  bulkAbroadRepresentativeFinish: () => ({type: actionTypes.BULK_ABROAD_REPRESENTATIVE_FINISH}),

  resetAbroadRepresentative: () => ({type: actionTypes.RESET_ABROAD_REPRESENTATIVE}),
}
